module.exports = __webpack_public_path__ + "static/media/dash.b18bc8ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/dash.svg
// module id = 851
// module chunks = 7